/**
 * AssignmentPanel — ЗӨРЧИЛ ХЭНД, ХЭЗЭЭ ХҮРТЭЛ хувиарлагдсаныг харуулна.
 *
 * ⚠ ЯАГААД ТУСДАА БЛОК ВЭ:
 *   «Хяналтын явц» нь бүртгэлийн ТӨЛӨВИЙН түүх (хэн хүлээн авав, хэн
 *   шийдвэрлэв) — тэр нь ДААЛГАВРЫГ харуулдаггүй. Хэрэглэгч «хэнд юу
 *   даалгасан, биелсэн үү» гэдгийг мэдэхийн тулд зөрчлийн блок руу орж,
 *   мөр бүрийн доорх жижиг бичгийг уншдаг байв.
 *
 *   Даалгавар нь бүртгэлийн ХАМГИЙН ҮЙЛДЭЛТЭЙ хэсэг тул явцын хажууд,
 *   тусдаа, төлөвийн өнгөтэйгөөр гаргав.
 *
 * ⚠ ХАРИУЦАГЧ ӨӨРӨӨ ХАРВАЛ «биелэлт илгээх» товч гарна — эс бөгөөс
 *   даалгавар бүртгэгддэг ч гүйцэтгэх зам байхгүй болно.
 */
import ThumbImg from "src/utils/mediaThumb";
import React, { useState } from "react";
import { Button, Modal, Input, Tag, Tooltip, message } from "antd";
import { submitAssignmentFix, verifyAssignment } from "src/api/assignment";

const STATUS = {
  open: { label: "Хүлээгдэж буй", color: "#CA8A04", bg: "#FEF6E7" },
  in_progress: { label: "Хийгдэж буй", color: "#0EA5E9", bg: "#E8F5FE" },
  submitted: { label: "Баталгаажуулах хүлээж буй", color: "#7C3AED", bg: "#F3EDFF" },
  closed: { label: "Биелсэн", color: "#16A34A", bg: "#E7F6EC" },
};

/** ТН-ийг харьцуулах — тэргүүн тэг нь энэ системд байнга зөрдөг. */
function sameTn(a, b) {
  const d = (v) => String(v || "").replace(/\D/g, "").replace(/^0+/, "");
  return !!d(a) && d(a) === d(b);
}

export default function AssignmentPanel({ data, myTn, isHse, onChanged }) {
  const [fixOf, setFixOf] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [verifyOf, setVerifyOf] = useState(null);
  const [verifyNote, setVerifyNote] = useState("");

  // Бүх шалгалтын зөрчлөөс ХАРИУЦАГЧТАЙГ нь цуглуулна
  const tasks = [];
  (data?.inspections || []).forEach((ins) => {
    (ins.findings || []).forEach((f) => {
      if ((f.responsible_name || "").trim()) tasks.push({ ...f, ins });
    });
  });

  if (!tasks.length) return null;

  const send = async () => {
    if (!note.trim()) return message.warning("Юу хийснээ бичнэ үү");
    setBusy(true);
    try {
      const d = await submitAssignmentFix(fixOf.id, { note: note.trim() });
      message.success(d?.message || "Илгээлээ");
      setFixOf(null);
      setNote("");
      onChanged?.();
    } catch (e) {
      message.error(e?.response?.data?.message || "Илгээж чадсангүй");
    } finally {
      setBusy(false);
    }
  };

  const decide = async (action) => {
    if (action === "reject" && !verifyNote.trim()) {
      return message.warning("Буцаах шалтгаанаа бичнэ үү");
    }
    setBusy(true);
    try {
      const d = await verifyAssignment(verifyOf.id, {
        action,
        note: verifyNote.trim(),
      });
      message.success(d?.message || "Хадгаллаа");
      setVerifyOf(null);
      setVerifyNote("");
      onChanged?.();
    } catch (e) {
      message.error(e?.response?.data?.message || "Хадгалж чадсангүй");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-surface rounded-lg border border-border-subtle shadow-sm p-5 mt-4">
      <h3 className="text-card-title text-primary font-bold mb-3">
        Хувиарласан үүрэг даалгавар ({tasks.length})
      </h3>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {tasks.map((t) => {
          const st = STATUS[t.fix_status || "open"] || STATUS.open;
          const mine = sameTn(t.responsible_tn, myTn);
          // ⚠ Баталгаажуулах эрхийг МӨР ТУС БҮРД тооцно: тухайн шалгалтыг
          //   хийсэн хүн, эсвэл ХАБЭА. Товчийг бүгдэд гаргаад backend-ээс
          //   403 авах нь хэрэглэгчийг төөрөгдүүлнэ.
          //   Мөн ӨӨРИЙН биелэлтийг өөрөө хүлээн авах боломжгүй.
          const canVerify =
            (isHse || sameTn(t.ins?.inspector_tn, myTn)) && !mine;
          // Хугацаа хэтэрсэн — хаагдсанаас бусад үед
          const overdue =
            t.is_overdue ??
            (t.due_date &&
              t.fix_status !== "closed" &&
              new Date(t.due_date) < new Date());
          return (
            <div
              key={t.id}
              style={{
                border: "1px solid #E6E9EF",
                borderLeft: `3px solid ${st.color}`,
                borderRadius: 8,
                padding: "9px 12px",
                background: "#fff",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    fontSize: 10.5,
                    fontWeight: 700,
                    padding: "1px 8px",
                    borderRadius: 999,
                    background: st.bg,
                    color: st.color,
                  }}
                >
                  {st.label}
                </span>
                {overdue ? (
                  <Tag color="red" style={{ marginInlineEnd: 0 }}>
                    хугацаа хэтэрсэн
                  </Tag>
                ) : null}
                {mine ? (
                  <Tag color="blue" style={{ marginInlineEnd: 0 }}>
                    таны даалгавар
                  </Tag>
                ) : null}
              </div>

              {/* ЮУГ хийх вэ */}
              <div style={{ fontSize: 12.5, color: "#1F2430", marginTop: 5 }}>
                <b>#{t.item_no}</b> {t.finding_text || t.item_text}
              </div>
              {t.violated_rule ? (
                <div style={{ fontSize: 11, color: "#8A94A6", marginTop: 2 }}>
                  {t.violated_rule}
                </div>
              ) : null}

              {/* ХЭН, ХЭЗЭЭ хүртэл */}
              <div style={{ fontSize: 11.5, color: "#5A6478", marginTop: 5 }}>
                <i className="fas fa-user-check" style={{ marginRight: 5 }} />
                {t.responsible_name}
                {t.due_date ? (
                  <span style={{ color: overdue ? "#DC2626" : "#5A6478" }}>
                    {" · "}
                    {t.due_date} хүртэл
                  </span>
                ) : null}
                {/* ⚠ «даалгасан» БИШ «ШАЛГАГЧ»: `inspector_name` нь
                    шалгалтыг ХИЙСЭН хүн, даалгавар хувиарласан хүнээс
                    өөр. /my-assignments дээр ч ижил алдаа байсныг
                    2026-10-04-нд зассан. */}
                <span style={{ color: "#A8AFBC" }}>
                  {" · шалгагч: "}
                  {t.ins?.inspector_name || "—"}
                </span>
              </div>

              {/* Буцаагдсан бол ШАЛТГААН нь хамгийн эхэнд харагдах ёстой */}
              {t.fix_reject_note ? (
                <div
                  style={{
                    marginTop: 6,
                    padding: "6px 9px",
                    background: "#FDECEC",
                    borderRadius: 6,
                    fontSize: 11.5,
                    color: "#8C2A22",
                  }}
                >
                  <b>Буцаасан:</b> {t.fix_reject_note}
                </div>
              ) : null}

              {/* Илгээсэн биелэлт */}
              {t.fix_note ? (
                <div
                  style={{
                    marginTop: 6,
                    padding: "6px 9px",
                    background: "#F6F8FB",
                    borderRadius: 6,
                    fontSize: 11.5,
                    color: "#3A4356",
                  }}
                >
                  <b>Биелэлт:</b> {t.fix_note}
                  {t.fix_photo_url ? (
                    <a href={t.fix_photo_url} target="_blank" rel="noreferrer">
                      {/* Холбоос нь эх хувь руу — зураг нь жижиг хувилбар */}
                      <ThumbImg
                        full={t.fix_photo_url}
                        alt="Биелэлтийн зураг"
                        style={{
                          display: "block",
                          marginTop: 5,
                          maxWidth: 200,
                          maxHeight: 140,
                          borderRadius: 6,
                          objectFit: "cover",
                        }}
                      />
                    </a>
                  ) : null}
                  <div style={{ fontSize: 10.5, color: "#A8AFBC", marginTop: 2 }}>
                    {t.fix_user_name}
                    {t.fix_date ? ` · ${String(t.fix_date).slice(0, 10)}` : ""}
                  </div>
                </div>
              ) : null}

              {/* Үйлдэл */}
              <div style={{ marginTop: 8, display: "flex", gap: 8 }}>
                {mine && t.fix_status !== "closed" ? (
                  <Button
                    size="small"
                    type="primary"
                    onClick={() => {
                      setFixOf(t);
                      setNote(t.fix_note || "");
                    }}
                  >
                    <i className="fas fa-check" style={{ marginRight: 5 }} />
                    {t.fix_status === "submitted"
                      ? "Биелэлтээ засах"
                      : "Биелэлт оруулах"}
                  </Button>
                ) : null}
                {canVerify && t.fix_status === "submitted" ? (
                  <Tooltip title="Хариуцагчийн илгээсэн биелэлтийг хүлээн авах эсвэл буцаах">
                    <Button
                      size="small"
                      onClick={() => {
                        setVerifyOf(t);
                        setVerifyNote("");
                      }}
                    >
                      Баталгаажуулах
                    </Button>
                  </Tooltip>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>

      {/* ── Биелэлт илгээх ─────────────────────────────────────────── */}
      <Modal
        open={!!fixOf}
        onCancel={() => setFixOf(null)}
        onOk={send}
        okText="Илгээх"
        cancelText="Болих"
        confirmLoading={busy}
        title="Биелэлт оруулах"
      >
        <div style={{ fontSize: 12.5, color: "#5A6478", marginBottom: 8 }}>
          <b>Даалгавар:</b> {fixOf?.finding_text || fixOf?.item_text}
        </div>
        <Input.TextArea
          rows={4}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Юуг хэрхэн засаж арилгасныг тодорхой бичнэ үү"
        />
        <div style={{ fontSize: 11, color: "#A8AFBC", marginTop: 6 }}>
          Илгээсний дараа шалгагч хүлээн авч хаана. Буцаагдвал шалтгаан нь
          энд харагдана.
        </div>
      </Modal>

      {/* ── Баталгаажуулах ─────────────────────────────────────────── */}
      <Modal
        open={!!verifyOf}
        onCancel={() => setVerifyOf(null)}
        footer={[
          <Button key="c" onClick={() => setVerifyOf(null)}>
            Болих
          </Button>,
          <Button key="r" danger loading={busy} onClick={() => decide("reject")}>
            Буцаах
          </Button>,
          <Button
            key="a"
            type="primary"
            loading={busy}
            onClick={() => decide("accept")}
          >
            Хүлээн авах
          </Button>,
        ]}
        title="Биелэлтийг баталгаажуулах"
      >
        <div style={{ fontSize: 12.5, color: "#5A6478", marginBottom: 8 }}>
          <b>Биелэлт:</b> {verifyOf?.fix_note || "—"}
          {verifyOf?.fix_photo_url ? (
            <a href={verifyOf.fix_photo_url} target="_blank" rel="noreferrer">
              <img
                src={verifyOf.fix_photo_url}
                alt="Биелэлтийн зураг"
                style={{ display: "block", marginTop: 6, maxWidth: 320, maxHeight: 220, borderRadius: 8 }}
              />
            </a>
          ) : null}
        </div>
        <Input.TextArea
          rows={3}
          value={verifyNote}
          onChange={(e) => setVerifyNote(e.target.value)}
          placeholder="Тэмдэглэл (буцаахад ЗААВАЛ — юуг дахин хийхийг бичнэ)"
        />
      </Modal>
    </div>
  );
}
